export const SIM_CARDS_CATEGORY_SLUG = 'nomreler-ve-sim-kartlar';
export const PHONE_NUMBER_PROPERTY_LEGACY_ID = 823;
export const PHONE_NUMBER_WILDCARD = '*';
export const PHONE_NUMBER_TOTAL_LENGTH = 10;
export const PHONE_NUMBER_OPERATOR_LENGTH = 3;
export const PHONE_NUMBER_SUBSCRIBER_LENGTH = 7;
export const EMPTY_PHONE_NUMBER_FILTER = PHONE_NUMBER_WILDCARD.repeat(
  PHONE_NUMBER_TOTAL_LENGTH
);
